import { F0Button } from '@factorialco/f0-react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

interface DisconnectButtonProps {
  onDisconnect: () => void
}

export const DisconnectButton = ({ onDisconnect }: DisconnectButtonProps) => {
  return (
    <F0Button
      label={i18n.t('meetings.room.control_bar.exit')}
      onClick={() => {
        track(trackingEvents.meetings.ControlBarLeaveButton)
        onDisconnect()
      }}
      size="lg"
      variant="default"
    />
  )
}
